import { useEffect, useRef } from "react";

export const usePrevious = <T>(value: T | null): T | undefined | null => {
  const ref = useRef<T | null>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
